import {
    createContext,
    useState,
    useEffect,
    useContext
} from 'react';
import { useSession } from 'contexts/session';
import { useSnackbar } from 'notistack';
import { easyquant } from "api";

const StrategyContext = createContext();

const initialFilter = {
    type: "momentum",
    universe: 'IBOV',
    look_back: 6,
    port_size: 10
}

const StrategyProvider = ({ children }) => {
    const { user } = useSession();
    const { enqueueSnackbar } = useSnackbar();
    const [momentum, setMomentum] = useState();
    const [filter, setFilter] = useState(initialFilter);
    const [backtest, setBacktest] = useState();
    const [loading, setLoading] = useState(false);

    const filterMomentum = () => {
        setLoading(true);
        easyquant.get('/strategy/search', {
            params: { ...filter }
        })
            .then(response => {
                if (!response.data.strategy) {
                    enqueueSnackbar('Essa estratégia não foi encontrada 😔', { variant: "info" })
                } else {
                    setMomentum(response.data.strategy)
                }
                setLoading(false);
            })
            .catch(err => {
                console.log(err)
                setLoading(false);
            })
    }

    const filterBacktest = (bt_interval = 10) => {
        setLoading(true);
        easyquant.get('/backtest/search', {
            params: { ...filter, bt_interval }
        })
            .then(response => {
                if (!response.data.backtest) {
                    enqueueSnackbar('Esse backtest não foi encontrado 😔', { variant: "info" })
                } else {
                    setBacktest(response.data.backtest)
                }
                setLoading(false);
            })
            .catch(err => {
                console.log(err)
                setLoading(false);
            })
    }

    const applyFilter = () => {
        filterMomentum();
        filterBacktest();
    }

    useEffect(() => {
        applyFilter()
        // eslint-disable-next-line
    }, [user])

    return (
        <StrategyContext.Provider
            value={{
                momentum,
                backtest,
                loading,
                filter,
                setFilter,
                applyFilter,
                filterBacktest
            }}>
            {children}
        </StrategyContext.Provider>
    );
}

const useStrategy = () => {
    const context = useContext(StrategyContext);

    if (!context) {
        throw new Error('useStrategy must be used within an StrategyProvider.');
    }

    return context;
}

export { StrategyProvider, useStrategy };